import * as types from '@/store/mutation-types'
import { Repository } from '@/repository/repository'
import config from '../../../config'

const apiRepository = Repository.call('filters')

const state = {
  orderedFilters: [],
  availableFilters: [],
  filter: {},
  states: []
}

const getters = {
  filtersSelected: state => state.filter,
  orderedFilters: state => state.orderedFilters,
  availableFilters: state => state.availableFilters,
  currentPage: state => state.filter.page + 1 || 1,
  states: state => state.states
}

const actions = {
  setOrderBOSelected ({ commit }, supplierOrderCode) {
    commit(types.SET_SELECTED_SUPPLIERORDERCODE, supplierOrderCode)
  },
  getFilters ({ commit }) {
    commit(types.SET_ORDER_FILTERS, config.orderFilters)
  },
  getAvailableFilters ({ commit }, type) {
    if (type === 'dispatch') {
      commit(types.SET_AVAILABLE_ORDER_FILTERS, config.orderDispatchFilters)
      return
    }

    commit(types.SET_AVAILABLE_ORDER_FILTERS, config.orderAvailableFilters)
  },
  setPyxisDateSelected ({ commit }, dates) {
    commit(types.SET_SELECTED_PYXISDATA, dates)
  },
  setDisponibilityDateSelected ({ commit }, dates) {
    commit(types.SET_SELECTED_DISPONIBILITYDATA, dates)
  },
  setMovStatesSelected ({ commit }, movStateOption) {
    commit(types.SET_SELECTED_STATE, movStateOption)
  },
  async getStates ({ commit }) {
    const states = await apiRepository.getStates()
    if (!states.level) return false

    commit(types.SET_STATES, states.data)
    return true
  },
  async getDeliveredEffectiveStatus ({ commit }) {
    const response = await apiRepository.getDeliveredEffectiveStatus()
    if (!response.level) return true

    commit(types.SET_DELIVERED_EFFECTIVE_STATUS, response.data)
    return false
  },
  setDeliveredEffectiveStatus ({ commit }, blob) {
    commit(types.SET_SELECTED_DELIVERED_EFFECTIVE_STATUS, blob)
  },
  flush ({ commit }) {
    commit(types.SET_FLUSH_FILTERS)
  },
  setSort ({ commit }, sortOption) {
    commit(types.SET_SELECTED_SORT, sortOption)
  },
  setOrd ({ commit }, ordOption) {
    commit(types.SET_SELECTED_ORD, ordOption)
  },
  setPage ({ commit }, page) {
    commit(types.SET_SELECTED_PAGE, page)
  },
  resetPage ({ commit }) {
    commit(types.RESET_SELECTED_PAGE)
  }
}

const mutations = {
  [types.SET_SELECTED_SUPPLIERORDERCODE] (state, supplierOrderCode) {
    state.filter.supplierOrderCode = supplierOrderCode
  },
  [types.SET_SELECTED_SORT] (state, sort) {
    state.filter.sort = sort
  },
  [types.SET_SELECTED_ORD] (state, ord) {
    state.filter.ord = ord
  },
  [types.SET_SELECTED_PAGE] (state, page) {
    state.filter.page = page
  },
  [types.RESET_SELECTED_PAGE] (state) {
    state.filter.page = 0
  },
  [types.SET_ORDER_FILTERS] (state, filters) {
    state.orderedFilters = filters
  },
  [types.SET_AVAILABLE_ORDER_FILTERS] (state, filters) {
    state.availableFilters = filters
  },
  [types.SET_FLUSH_FILTERS] (state) {
    state.filter = {}
  },
  [types.SET_STATES] (state, states) {
    state.states = states
  },
  [types.SET_SELECTED_PYXISDATA] (state, dates) {
    state.filter.pyxisDateBegin = dates.pyxisDateBegin
    state.filter.pyxisDateEnd = dates.pyxisDateEnd
  },
  [types.SET_SELECTED_DISPONIBILITYDATA] (state, dates) {
    state.filter.availabilityDateBegin = dates.availabilityDateBegin
    state.filter.availabilityDateEnd = dates.availabilityDateEnd
  },
  [types.SET_SELECTED_STATE] (state, movStateOption) {
    state.filter = {...state.filter, movStateOption}
  },
  [types.SET_DELIVERED_EFFECTIVE_STATUS] (state, deliveredEffectiveStatus) {
    state.filter = { ...state.filter, deliveredEffectiveStatus }
  },
  [types.SET_SELECTED_DELIVERED_EFFECTIVE_STATUS] (
    state,
    deliveredEffectiveStatusList = []
  ) {
    state.filter = { ...state.filter, deliveredEffectiveStatusList }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filters.js